import p, { PureComponent as it } from "react";
import { clsx as tt } from "../../../clsx/dist/clsx.js";
import ot from "../../../react-smooth/es6/Animate.js";
import K from "../../../../_virtual/isFunction.js";
import C from "../../../../_virtual/max.js";
import q from "../../../../_virtual/isNil.js";
import st from "../../../../_virtual/isNaN.js";
import G from "../../../../_virtual/isEqual.js";
import { Curve as F } from "../shape/Curve.js";
import { Dot as lt } from "../shape/Dot.js";
import { Layer as z } from "../container/Layer.js";
import { LabelList as ut } from "../component/LabelList.js";
import { Global as ct } from "../util/Global.js";
import { isNumber as B, interpolateNumber as N, uniqueId as ft } from "../util/DataUtils.js";
import { getValueByDataKey as J, getCateCoordinateOfLine as Q } from "../util/ChartUtils.js";
import { filterProps as R, hasClipDot as pt } from "../util/ReactUtils.js";
var mt = ["layout", "type", "stroke", "connectNulls", "isRange", "ref"], dt = ["key"], et;
function I(t) {
  "@babel/helpers - typeof";
  return I = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, I(t);
}
function rt(t, e) {
  if (t == null) return {};
  var n = ht(t, e), r, a;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(t);
    for (a = 0; a < i.length; a++)
      r = i[a], !(e.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(t, r) && (n[r] = t[r]);
  }
  return n;
}
function ht(t, e) {
  if (t == null) return {};
  var n = {};
  for (var r in t)
    if (Object.prototype.hasOwnProperty.call(t, r)) {
      if (e.indexOf(r) >= 0) continue;
      n[r] = t[r];
    }
  return n;
}
function D() {
  return D = Object.assign ? Object.assign.bind() : function(t) {
    for (var e = 1; e < arguments.length; e++) {
      var n = arguments[e];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
    }
    return t;
  }, D.apply(this, arguments);
}
function U(t, e) {
  var n = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(t);
    e && (r = r.filter(function(a) {
      return Object.getOwnPropertyDescriptor(t, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function j(t) {
  for (var e = 1; e < arguments.length; e++) {
    var n = arguments[e] != null ? arguments[e] : {};
    e % 2 ? U(Object(n), !0).forEach(function(r) {
      w(t, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : U(Object(n)).forEach(function(r) {
      Object.defineProperty(t, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return t;
}
function vt(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function Z(t, e) {
  for (var n = 0; n < e.length; n++) {
    var r = e[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, at(r.key), r);
  }
}
function yt(t, e, n) {
  return e && Z(t.prototype, e), n && Z(t, n), Object.defineProperty(t, "prototype", { writable: !1 }), t;
}
function bt(t, e, n) {
  return e = T(e), At(t, nt() ? Reflect.construct(e, n || [], T(t).constructor) : e.apply(t, n));
}
function At(t, e) {
  if (e && (I(e) === "object" || typeof e == "function"))
    return e;
  if (e !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return gt(t);
}
function gt(t) {
  if (t === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
function nt() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (nt = function() {
    return !!t;
  })();
}
function T(t) {
  return T = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, T(t);
}
function xt(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && H(t, e);
}
function H(t, e) {
  return H = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, a) {
    return r.__proto__ = a, r;
  }, H(t, e);
}
function w(t, e, n) {
  return e = at(e), e in t ? Object.defineProperty(t, e, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = n, t;
}
function at(t) {
  var e = Pt(t, "string");
  return I(e) == "symbol" ? e : e + "";
}
function Pt(t, e) {
  if (I(t) != "object" || !t) return t;
  var n = t[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(t, e);
    if (I(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(t);
}
var M = /* @__PURE__ */ function(t) {
  function e() {
    var n;
    vt(this, e);
    for (var r = arguments.length, a = new Array(r), i = 0; i < r; i++)
      a[i] = arguments[i];
    return n = bt(this, e, [].concat(a)), w(n, "state", {
      isAnimationFinished: !0
    }), w(n, "id", ft("recharts-area-")), w(n, "handleAnimationEnd", function() {
      var o = n.props.onAnimationEnd;
      n.setState({
        isAnimationFinished: !0
      }), K(o) && o();
    }), w(n, "handleAnimationStart", function() {
      var o = n.props.onAnimationStart;
      n.setState({
        isAnimationFinished: !1
      }), K(o) && o();
    }), n;
  }
  return xt(e, t), yt(e, [{
    key: "renderDots",
    value: function(r, a, i) {
      var o = this.props.isAnimationActive, s = this.state.isAnimationFinished;
      if (o && !s)
        return null;
      var u = this.props, l = u.dot, f = u.points, c = u.dataKey, m = R(this.props, !1), A = R(l, !0), g = f.map(function(v, O) {
        var y = j(j(j({
          key: "dot-".concat(O),
          r: 3
        }, m), A), {}, {
          index: O,
          cx: v.x,
          cy: v.y,
          dataKey: c,
          value: v.value,
          payload: v.payload,
          points: f
        });
        return e.renderDotItem(l, y);
      }), x = {
        clipPath: r ? "url(#clipPath-".concat(a ? "" : "dots-").concat(i, ")") : null
      };
      return /* @__PURE__ */ p.createElement(z, D({
        className: "recharts-area-dots"
      }, x), g);
    }
  }, {
    key: "renderHorizontalRect",
    value: function(r) {
      var a = this.props, i = a.baseLine, o = a.points, s = a.strokeWidth, u = o[0].x, l = o[o.length - 1].x, f = r * Math.abs(u - l), c = C(o.map(function(m) {
        return m.y || 0;
      }));
      return B(i) && typeof i == "number" ? c = Math.max(i, c) : i && Array.isArray(i) && i.length && (c = Math.max(C(i.map(function(m) {
        return m.y || 0;
      })), c)), B(c) ? /* @__PURE__ */ p.createElement("rect", {
        x: u < l ? u : u - f,
        y: 0,
        width: f,
        height: Math.floor(c + (s ? parseInt("".concat(s), 10) : 1))
      }) : null;
    }
  }, {
    key: "renderVerticalRect",
    value: function(r) {
      var a = this.props, i = a.baseLine, o = a.points, s = a.strokeWidth, u = o[0].y, l = o[o.length - 1].y, f = r * Math.abs(u - l), c = C(o.map(function(m) {
        return m.x || 0;
      }));
      return B(i) && typeof i == "number" ? c = Math.max(i, c) : i && Array.isArray(i) && i.length && (c = Math.max(C(i.map(function(m) {
        return m.x || 0;
      })), c)), B(c) ? /* @__PURE__ */ p.createElement("rect", {
        x: 0,
        y: u < l ? u : u - f,
        width: c + (s ? parseInt("".concat(s), 10) : 1),
        height: Math.floor(f)
      }) : null;
    }
  }, {
    key: "renderClipRect",
    value: function(r) {
      var a = this.props.layout;
      return a === "vertical" ? this.renderVerticalRect(r) : this.renderHorizontalRect(r);
    }
  }, {
    key: "renderAreaStatically",
    value: function(r, a, i, o) {
      var s = this.props, u = s.layout, l = s.type, f = s.stroke, c = s.connectNulls, m = s.isRange;
      s.ref;
      var A = rt(s, mt);
      return /* @__PURE__ */ p.createElement(z, {
        clipPath: i ? "url(#clipPath-".concat(o, ")") : null
      }, /* @__PURE__ */ p.createElement(F, D({}, R(A, !0), {
        points: r,
        connectNulls: c,
        type: l,
        baseLine: a,
        layout: u,
        stroke: "none",
        className: "recharts-area-area"
      })), f !== "none" && /* @__PURE__ */ p.createElement(F, D({}, R(this.props, !1), {
        className: "recharts-area-curve",
        layout: u,
        type: l,
        connectNulls: c,
        fill: "none",
        points: r
      })), f !== "none" && m && /* @__PURE__ */ p.createElement(F, D({}, R(this.props, !1), {
        className: "recharts-area-curve",
        layout: u,
        type: l,
        connectNulls: c,
        fill: "none",
        points: a
      })));
    }
  }, {
    key: "renderAreaWithAnimation",
    value: function(r, a) {
      var i = this, o = this.props, s = o.points, u = o.baseLine, l = o.isAnimationActive, f = o.animationBegin, c = o.animationDuration, m = o.animationEasing, A = o.animationId, g = this.state, x = g.prevPoints, v = g.prevBaseLine;
      return /* @__PURE__ */ p.createElement(ot, {
        begin: f,
        duration: c,
        isActive: l,
        easing: m,
        from: {
          t: 0
        },
        to: {
          t: 1
        },
        key: "area-".concat(A),
        onAnimationEnd: this.handleAnimationEnd,
        onAnimationStart: this.handleAnimationStart
      }, function(O) {
        var y = O.t;
        if (x) {
          var _ = x.length / s.length, d = s.map(function(P, L) {
            var k = Math.floor(L * _);
            if (x[k]) {
              var S = x[k], V = N(S.x, P.x), W = N(S.y, P.y);
              return j(j({}, P), {}, {
                x: V(y),
                y: W(y)
              });
            }
            return P;
          }), h;
          if (B(u) && typeof u == "number") {
            var b = N(v, u);
            h = b(y);
          } else if (q(u) || st(u)) {
            var E = N(v, 0);
            h = E(y);
          } else
            h = u.map(function(P, L) {
              var k = Math.floor(L * _);
              if (v[k]) {
                var S = v[k], V = N(S.x, P.x), W = N(S.y, P.y);
                return j(j({}, P), {}, {
                  x: V(y),
                  y: W(y)
                });
              }
              return P;
            });
          return i.renderAreaStatically(d, h, r, a);
        }
        return /* @__PURE__ */ p.createElement(z, null, /* @__PURE__ */ p.createElement("defs", null, /* @__PURE__ */ p.createElement("clipPath", {
          id: "animationClipPath-".concat(a)
        }, i.renderClipRect(y))), /* @__PURE__ */ p.createElement(z, {
          clipPath: "url(#animationClipPath-".concat(a, ")")
        }, i.renderAreaStatically(s, u, r, a)));
      });
    }
  }, {
    key: "renderArea",
    value: function(r, a) {
      var i = this.props, o = i.points, s = i.baseLine, u = i.isAnimationActive, l = this.state, f = l.prevPoints, c = l.prevBaseLine, m = l.totalLength;
      return u && o && o.length && (!f && m > 0 || !G(f, o) || !G(c, s)) ? this.renderAreaWithAnimation(r, a) : this.renderAreaStatically(o, s, r, a);
    }
  }, {
    key: "render",
    value: function() {
      var r, a = this.props, i = a.hide, o = a.dot, s = a.points, u = a.className, l = a.top, f = a.left, c = a.xAxis, m = a.yAxis, A = a.width, g = a.height, x = a.isAnimationActive, v = a.id;
      if (i || !s || !s.length)
        return null;
      var O = this.state.isAnimationFinished, y = s.length === 1, _ = tt("recharts-area", u), d = c && c.allowDataOverflow, h = m && m.allowDataOverflow, b = d || h, E = q(v) ? this.id : v, P = (r = R(o, !1)) !== null && r !== void 0 ? r : {
        r: 3,
        strokeWidth: 2
      }, L = P.r, k = L === void 0 ? 3 : L, S = P.strokeWidth, V = S === void 0 ? 2 : S, W = pt(o) ? o : {}, X = W.clipDot, Y = X === void 0 ? !0 : X, $ = k * 2 + V;
      return /* @__PURE__ */ p.createElement(z, {
        className: _
      }, d || h ? /* @__PURE__ */ p.createElement("defs", null, /* @__PURE__ */ p.createElement("clipPath", {
        id: "clipPath-".concat(E)
      }, /* @__PURE__ */ p.createElement("rect", {
        x: d ? f : f - A / 2,
        y: h ? l : l - g / 2,
        width: d ? A : A * 2,
        height: h ? g : g * 2
      })), !Y && /* @__PURE__ */ p.createElement("clipPath", {
        id: "clipPath-dots-".concat(E)
      }, /* @__PURE__ */ p.createElement("rect", {
        x: f - $ / 2,
        y: l - $ / 2,
        width: A + $,
        height: g + $
      }))) : null, y ? null : this.renderArea(b, E), (o || y) && this.renderDots(b, Y, E), (!x || O) && ut.renderCallByParent(this.props, s));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function(r, a) {
      return r.animationId !== a.prevAnimationId ? {
        prevAnimationId: r.animationId,
        curPoints: r.points,
        curBaseLine: r.baseLine,
        prevPoints: a.curPoints,
        prevBaseLine: a.curBaseLine
      } : r.points !== a.curPoints || r.baseLine !== a.curBaseLine ? {
        curPoints: r.points,
        curBaseLine: r.baseLine
      } : null;
    }
  }]);
}(it);
et = M;
w(M, "displayName", "Area");
w(M, "defaultProps", {
  stroke: "#3182bd",
  fill: "#3182bd",
  fillOpacity: 0.6,
  xAxisId: 0,
  yAxisId: 0,
  legendType: "line",
  connectNulls: !1,
  // points of area
  points: [],
  dot: !1,
  activeDot: !0,
  hide: !1,
  isAnimationActive: !ct.isSsr,
  animationBegin: 0,
  animationDuration: 1500,
  animationEasing: "ease"
});
w(M, "getBaseValue", function(t, e, n, r) {
  var a = t.layout, i = t.baseValue, o = e.props.baseValue, s = o ?? i;
  if (B(s) && typeof s == "number")
    return s;
  var u = a === "horizontal" ? r : n, l = u.scale.domain();
  if (u.type === "number") {
    var f = Math.max(l[0], l[1]), c = Math.min(l[0], l[1]);
    return s === "dataMin" ? c : s === "dataMax" || f < 0 ? f : Math.max(Math.min(l[0], l[1]), 0);
  }
  return s === "dataMin" ? l[0] : s === "dataMax" ? l[1] : l[0];
});
w(M, "getComposedData", function(t) {
  var e = t.props, n = t.item, r = t.xAxis, a = t.yAxis, i = t.xAxisTicks, o = t.yAxisTicks, s = t.bandSize, u = t.dataKey, l = t.stackedData, f = t.dataStartIndex, c = t.displayedData, m = t.offset, A = e.layout, g = l && l.length, x = et.getBaseValue(e, n, r, a), v = A === "horizontal", O = !1, y = c.map(function(d, h) {
    var b;
    g ? b = l[f + h] : (b = J(d, u), Array.isArray(b) ? O = !0 : b = [x, b]);
    var E = b[1] == null || g && J(d, u) == null;
    return v ? {
      x: Q({
        axis: r,
        ticks: i,
        bandSize: s,
        entry: d,
        index: h
      }),
      y: E ? null : a.scale(b[1]),
      value: b,
      payload: d
    } : {
      x: E ? null : r.scale(b[1]),
      y: Q({
        axis: a,
        ticks: o,
        bandSize: s,
        entry: d,
        index: h
      }),
      value: b,
      payload: d
    };
  }), _;
  return g || O ? _ = y.map(function(d) {
    var h = Array.isArray(d.value) ? d.value[0] : null;
    return v ? {
      x: d.x,
      y: h != null && d.y != null ? a.scale(h) : null
    } : {
      x: h != null ? r.scale(h) : null,
      y: d.y
    };
  }) : _ = v ? a.scale(x) : r.scale(x), j({
    points: y,
    baseLine: _,
    layout: A,
    isRange: O
  }, m);
});
w(M, "renderDotItem", function(t, e) {
  var n;
  if (/* @__PURE__ */ p.isValidElement(t))
    n = /* @__PURE__ */ p.cloneElement(t, e);
  else if (K(t))
    n = t(e);
  else {
    var r = tt("recharts-area-dot", typeof t != "boolean" ? t.className : ""), a = e.key, i = rt(e, dt);
    n = /* @__PURE__ */ p.createElement(lt, D({}, i, {
      key: a,
      className: r
    }));
  }
  return n;
});
export {
  M as Area
};
